import { AppDispatch } from "redux/store";
import { CallLambda } from "./CallLambda";
import { mergeJobsByIDs } from "redux/slices/user";
import Job from "redux/classes/Job";
import Session from "redux/classes/Session";

/**
 * Targeted full-row fetch for a list of job IDs the Console doesn't yet have
 * in redux. Used as a follow-up to LoadJobStatesAction when the light Query
 * surfaces IDs not already in state.user.jobs — the new rows need their full
 * field set (alias, name, runBy, etc.) to render in the Jobs table.
 *
 * Server enforces the same is_admin / user-scoping as everywhere else, so a
 * non-admin requesting another user's job ID will simply not get it back.
 */
export function LoadJobsByIDsAction(session: Session, jobIDs: string[]) {
    return async (dispatch: AppDispatch) => {
        if (!jobIDs || jobIDs.length === 0) return;

        const payload = JSON.stringify({
            "action": "loadJobsByIDs",
            "job_ids": jobIDs,
        });

        let response: { status: number; data: any };
        try {
            response = await dispatch(CallLambda(session, "tableGrabber", payload));
        } catch {
            return;
        }

        if (response.status !== 200 || !Array.isArray(response.data?.jobs)) {
            return;
        }

        const jobs = response.data.jobs.map((job: any) => new Job(
            job.job_id,
            job.model_id,
            job.cust_id,
            job.user_id,
            job.alias,
            job.description,
            job.job_name,
            job.result_name,
            job.task_id,
            job.job_status,
            new Date(job.start_time),
            new Date(job.end_time),
            new Date(job.schedule_time),
            job.schedule_type,
        ));

        dispatch(mergeJobsByIDs({ jobs }));
    };
}
